export function dateTimeZoneOffset(dateString){
  let date = new Date(dateString)
  let time = date.getTime()
  let timestamp = date.getTimezoneOffset()*60*1000
  time = time + timestamp;
  date.setTime(time);
  return date;
}